/* import __COLOCATED_TEMPLATE__ from './request-wrapper.hbs'; */
import { classNameBindings, classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './request-wrapper.module.scss';

@classic
@classNames('d-flex', 'flex-wrap', styles.component)
@classNameBindings(
  'currentStepClass',
  'prescreenerClass',
  'fullScreen:full-screen:',
  'clinicianSearchLayoutClass:clinician-search-layout'
)
export default class RequestRequestWrapper extends Component {
  @service prescreener;
  @service router;

  @computed('router.currentRouteName')
  get clinicianSearchLayoutClass() {
    let currentRouteName = this.router.currentRouteName;
    return currentRouteName && currentRouteName.endsWith('.clinician-search');
  }

  @computed('activeSteps.@each.isActive')
  get currentStep() {
    return this.activeSteps.find(({ isActive }) => isActive);
  }

  @computed('currentStep.route')
  get currentStepClass() {
    if (!this.currentStep) {
      // eslint-disable-next-line getter-return
      return;
    }

    return `${this.currentStep.route}-step`;
  }

  @computed('activeSteps.[]', 'currentStep')
  get previousStep() {
    if (this.get('currentStep.previousStepDisabled')) {
      return null;
    }
    let currentIndex = this.activeSteps.indexOf(this.currentStep);
    // Native Array#at(-1) returns the last element; Ember objectAt(-1) returned
    // undefined. Guard so the first step does not show the terminal step
    // (e.g. "Unavailable") as a previous-step breadcrumb.
    if (currentIndex <= 0) {
      return null;
    }
    return this.activeSteps.at(currentIndex - 1);
  }

  @computed('prescreener.isPrescreenerEnabled')
  get prescreenerClass() {
    return this.prescreener.isPrescreenerEnabled ? 'use-prescreener' : null;
  }
}
